import React from 'react';
import { AUTH_REDIRECT_ROUTES } from '../../config/routes';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

function AuthRedirect(props) {
    const history = useHistory();
    const {
        authData
    } = props

    let user = authData.user ? authData.user : { role: "none" };
    let authRedirectConfig = AUTH_REDIRECT_ROUTES.ROLES[user.role];

    if (authData.isSignedIn && authRedirectConfig) {
        if (authData.user && authData.user.isProfileUpdated === false) {
            history.push(authRedirectConfig.profile);
        } else {
            history.push(authRedirectConfig.default);
        }
    }

    return null;
}

AuthRedirect.defaultProps = {
    authData: {}
}

const mapStateToProps = state => ({
    authData: state.AUTH
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AuthRedirect);